import React, { useState, useEffect } from 'react';
import { X, Smartphone, Download } from 'lucide-react';

const PWABanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    // Vérifier si l'utilisateur a déjà fermé la bannière
    const dismissed = localStorage.getItem('pwa-banner-dismissed');
    if (dismissed) return;

    // Vérifier si c'est un appareil mobile
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (!isMobile) return;

    // Vérifier si l'app est déjà installée (mode standalone)
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || 
                         window.navigator.standalone === true;
    if (isStandalone) return;

    // Écouter l'événement beforeinstallprompt (Chrome/Android)
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowBanner(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    // Pour iOS/Safari, afficher la bannière avec instructions
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (isIOS) {
      // Attendre un peu avant d'afficher sur iOS
      setTimeout(() => setShowBanner(true), 3000);
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstall = async () => {
    if (deferredPrompt) {
      // Chrome/Android - déclencher le prompt d'installation
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        setShowBanner(false);
      }
      setDeferredPrompt(null);
    } else {
      // iOS - afficher les instructions
      alert(
        "Pour installer Hilanta sur votre iPhone :\n\n" +
        "1. Appuyez sur l'icône de partage (carré avec flèche)\n" +
        "2. Faites défiler et appuyez sur \"Sur l'écran d'accueil\"\n" +
        "3. Appuyez sur \"Ajouter\""
      );
    }
  };

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem('pwa-banner-dismissed', 'true');
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 animate-slide-up">
      <div className="bg-gradient-to-r from-[#C4785A] to-[#D4956A] text-white px-4 py-3 shadow-lg">
        <div className="max-w-screen-lg mx-auto flex items-center justify-between gap-3">
          {/* Icône et texte */}
          <div className="flex items-center gap-3 flex-1">
            <div className="bg-white/20 rounded-full p-2 flex-shrink-0">
              <Smartphone className="w-5 h-5" />
            </div>
            <p className="text-sm font-medium leading-tight">
              Installez Hilanta sur votre téléphone pour un accès rapide à vos réservations !
            </p>
          </div>

          {/* Boutons */}
          <div className="flex items-center gap-2 flex-shrink-0">
            <button
              onClick={handleInstall}
              className="bg-white text-[#C4785A] px-3 py-1.5 rounded-full text-sm font-semibold flex items-center gap-1.5 hover:bg-gray-100 transition-colors"
            >
              <Download className="w-4 h-4" />
              <span className="hidden sm:inline">Installer</span>
            </button>
            <button
              onClick={handleDismiss}
              className="p-1.5 hover:bg-white/20 rounded-full transition-colors"
              aria-label="Fermer"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PWABanner;
